<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XU241q/tc-custom/9781626866133.jpg?1728259422591" alt="This image is the cover for the book Funniest Joke Book Ever!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Funniest Joke Book Ever!
      </h1>
      <p class="bookDescription body article font2">
        <b>Over 500 giggles, groans, and belly laughs!</b><br/>  <br/> Kids can’t resist sharing jokes (even you try to stop them), so they always need a fresh supply. We’ve stuffed the pages of this little joke book with the funniest jokes we could find. Old favorites, new favorites, and a few festering stinkers, all guaranteed to make kids laugh out loud. You’ll find Q&amp;A jokes, knock-knock jokes, riddles, and one-liners. And, of course, we’ve included entire chapters of those all-time kid-pleasers: elephant jokes, pirate jokes, and space jokes. Here’s a sampling:<br/>  <br/> What's black and white, black and white, black and white? <i>A penguin rolling down a hill.</i><br/>  <br/> Why don’t zombies eat clowns? <i>They taste funny.</i><br/>  <br/> Why did the hen scold her chicks? <i>They were using fowl language.</i><br/>  <br/> What kind of books do skunks read? <i>Best-smellers!</i><br/>  <br/> How does Darth Vader like his toast? <i>On the dark side.</i><br/>  <br/> . . . and many more!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Editors of Portable Press
      </h2>
      
      <p class="authorDescription body article">Portable Press is a tight-knit group of writers, researchers, and editors who are responsible for some of the publishing industry&rsquo;s most popular non-fiction trivia and facts books. Aside from creating the fan-favorite Uncle John&rsquo;s Bathroom Reader series (more than 16 million books in print since 1988), the Portable Press team also specializes in regional and kids&rsquo; titles, plus gift books, activity books, and whatever else strikes their fancy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Portable Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?458f837e